import React from 'react';
import ATable from '../../common/table';

const TransactionGroupsTable = (props) => {


    const columns = [{
        header: "S/N",
        width: 50,
        render: row => (<div>{props.paginatedCallBack(row.viewIndex)}</div>)
    },
    {
        header: "Name",
        accessor: "name"
    },
    {
        header: "Channel",
        accessor: "channel",
        width :150
    },
    {
        header: "Store",
        accessor: "store",
    },
    {
        header: "Customer Ref. Parameter",
        accessor: "customerReference",
       
    },
    {
        header: "Transaction Ref. Parameter",
        accessor: "transactionReference",
       
    },
    {
        header: "Additional Parameters",
        render: row => { return (row.row.additionalParameters ? row.row.additionalParameters.join(",") : "") },
        width : 300
    }
    ];
    return (
        <ATable
            className="-striped -highlight"
            tableData={props.transactionGroups}
            columns={columns}
            onChange={props.onTableChange || null}
            manual
            {...props} />
    )
};

export default TransactionGroupsTable;


// WEBPACK FOOTER //
// ./src/components/admin/transactionGroups/transactionGroupsTable.js